var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "newsletter-form-container" }, [
    _c("span", [_vm._v(_vm._s(_vm.$t("home.newsletter")))]),
    _vm._v(" "),
    _c("div", { staticClass: "input-container" }, [
      _c("div", { staticClass: "input-container-inner" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.email,
              expression: "email"
            }
          ],
          attrs: { placeholder: _vm.$t("home.newsletter-your-email") },
          domProps: { value: _vm.email },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.email = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c("a", { on: { click: _vm.submit } }, [
          _vm._v(_vm._s(_vm.$t("home.newsletter-i-register")))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "input-legend" }, [
        _vm._v(_vm._s(_vm.$t("home.newsletter-confidentiality")))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "social-container" }, [
      _c("span", [_vm._v(_vm._s(_vm.$t("home.newsletter-follow-us")))]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _vm._m(2)
    ]),
    _vm._v(" "),
    !!_vm.message
      ? _c("div", { staticClass: "newsletter-modal-container" }, [
          _c("div", { staticClass: "newsletter-modal" }, [
            _c("p", [_vm._v(_vm._s(_vm.message))]),
            _vm._v(" "),
            _c("div", { staticClass: "actions" }, [
              _c("div", { staticClass: "spacer" }),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass:
                    "md-button md-button md-raised md-primary md-theme-default md-theme-default",
                  on: {
                    click: function($event) {
                      _vm.message = ""
                    }
                  }
                },
                [
                  _c("div", { staticClass: "md-ripple" }, [
                    _c("div", { staticClass: "md-button-content" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("global.close")) +
                          "\n                        "
                      )
                    ])
                  ])
                ]
              )
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        attrs: {
          href: "https://www.facebook.com/pg/openfly.fr",
          target: "_blank"
        }
      },
      [_c("img", { attrs: { src: "/imgs/facebook.svg" } })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      { attrs: { href: "https://twitter.com/openfly_fr", target: "_blank" } },
      [_c("img", { attrs: { src: "/imgs/twitter.svg" } })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        attrs: {
          href: "https://www.linkedin.com/company/openfly",
          target: "_blank"
        }
      },
      [_c("img", { attrs: { src: "/imgs/linkedin.svg" } })]
    )
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cd963f26", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd963f26","hasScoped":true,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/NewsletterRegistrationForm.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-cd963f26","hasScoped":true,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/NewsletterRegistrationForm.vue
// module chunks = 1 2 3